// extracted by mini-css-extract-plugin
export default {"fr-view":"Onboarding_fr-view__abH5d","sub-page":"Onboarding_sub-page__QKj1C","logo":"Onboarding_logo__J7wRy"};